<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="categoryOperate">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        ></el-pagination>
      </div>
      <div class="categoryTable">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="序号" width="60" />
          <el-table-column prop="image" label="形象图" width="120">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.image"
                :fit="fit"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="image" label="轮播图" width="200">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px; margin-right: 5px"
                :src="item.imageUrl"
                :fit="fit"
                v-for="item in scope.row.storeBannerVos"
                :key="item"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="门店名称" width="160" />
          <el-table-column prop="typeId" label="分类" width="120">
            <template slot-scope="scope">
              <span>{{ getType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discount" label="买单折扣" width="100" />
          <el-table-column prop="detailed" label="详细地址" width="160">
            <template slot-scope="scope">
              <span>{{ getAddress(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkman" label="联系人" wdth="160" />
          <el-table-column prop="phone" label="联系电话" width="160" />
          <el-table-column prop="isPick" label="同城自提" width="80">
            <template slot-scope="scope">
              <span>{{ !scope.row.isPick ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="postage" label="同城配送" width="80">
            <template slot-scope="scope">
              <span>{{ !scope.row.postage ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="postage" label="同城配送费用" width="120" />
          <!-- <el-table-column label="操作" width="300" show-overflow-tooltip> -->
          <el-table-column label="操作" width="500">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="updateStroeInfo(scope.$index, scope.row)"
                >修改信息</el-button
              >
              <el-button
                size="mini"
                @click="handleUpload(scope.$index, scope.row)"
                >编辑形象图</el-button
              >
              <el-button
                size="mini"
                @click="onUploadBanner(scope.$index, scope.row)"
                >编辑轮播图</el-button
              >

              <el-button
                size="mini"
                @click="handleOpenClose(scope.$index, scope.row)"
                >{{ getStatusText(scope.row) }}
              </el-button>
              <!-- 进销存门店的关闭开启 -->
              <!-- <el-button
                size="mini"
                :class="getButtonClass(scope.row)"
                @click="handleSaleOpenClose(scope.$index, scope.row)"
                >{{ getSaleStatusText(scope.row) }}
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="编辑形象图"
        :visible.sync="addDialogVisible"
        width="40%"
        center
        :append-to-body="true"
      >
        <el-form :label-position="left" label-width="100px">
          <el-form-item label="门店形象图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_uploadImage()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="编辑轮播图"
        :visible.sync="bannerModal"
        width="40%"
        center
        :append-to-body="true"
      >
        <el-form :label-position="left" label-width="100px">
          <el-form-item label="轮播图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadManyFile"
              :on-remove="handleManyRemove"
              :limit="100"
              :file-list="banners"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onCancelBanner">取 消</el-button>
          <el-button type="primary" @click="onSubmitBanner()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑轮播图" :visible.sync="bannerModal"
        width="40%"
        center
        :append-to-body="true"
      >
        <el-form :label-position="left" label-width="100px">
          <el-form-item label="轮播图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadManyFile"
              :on-remove="handleManyRemove"
              :limit="100"
              :file-list="banners"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onCancelBanner">取 消</el-button>
          <el-button type="primary" @click="onSubmitBanner()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getStoreAuditList,
  getStoreType,
  uploadFile1,
  uploadStoreImage,
  postStoreOpenClose,
  updateStoreBanner,
  postSaleStoreOpenClose, //进销存门店的开启关闭
} from "api/request";
import { ERR_OK } from "api/config";
import { loadingInstance, Error } from "common/js/util";

export default {
  components: {
    MSidebar,
    MHeader,
  },
  data() {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      paginationShow: false,
      addDialogVisible: false,
      list: [],
      storeTypeList: [], // 门店类型列表
      multipleSelection: [],
      controlData: {},
      imageUrl: null,
      fileList: [],
      bannerModal: false,
      thisStore: {},
      banners: [],
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/",
      });
    } else {
      this.getStoreType();
      this._getList();
    }
  },
  methods: {
    // 进销存门店的关闭开启
    getSaleStatusText(row) {
      if (row.isErp == "0") return "点击开启进销存";
      if (row.isErp == "1") return "点击关闭进销存";
      return "";
    },
    // 进销存门店的关闭开启
    handleSaleOpenClose(index, row) {
      var isErp;
      if (row.isErp == "1") isErp = "1";
      if (row.isErp == "0") isErp = "0";
      let param = {
        storeId: row.id,
        isErp: isErp,
      };
      loadingInstance(Loading);
      postSaleStoreOpenClose(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 确定进入商城按钮类的方法
    getButtonClass(row) {
      if (row.isErp == "1") {
        // return ""; // 默认类或无类
        return "red-button"; // 使按钮变红的类
      } else if (row.isErp == "0") {
        // return "red-button"; // 使按钮变红的类
        return ""; // 默认类或无类
      }
    },
    onCancelBanner() {
      this.banners = [];
      this.bannerModal = false;
    },
    onSubmitBanner() {
      updateStoreBanner({
        id: this.thisStore.id,
        banners: this.banners,
      }).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.banners = [];
          this.bannerModal = false;
        } else {
          Error(this, res);
        }
      });
    },
    uploadManyFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);
      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.banners.push(res.data);
        } else {
          Error(this, res);
        }
      });
    },
    handleManyRemove(file, fileList) {
      this.banners = [];
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          this.banners.push(fileList[i].url);
        }
      }
    },
    onUploadBanner(index, row) {
      this.bannerModal = true;
      this.thisStore = row;
    },
    handleOpenClose(index, row) {
      var newStatus;
      if (row.status == "2") newStatus = "1";
      if (row.status == "1") newStatus = "2";
      let param = {
        id: row.id,
        status: newStatus,
      };
      loadingInstance(Loading);
      postStoreOpenClose(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    getStatusText(row) {
      if (row.status == "2") return "开启";
      if (row.status == "1") return "关闭";
      return "";
    },
    getAddress(row) {
      return (
        row.province + row.county + row.city + (row.street || "") + row.detailed
      );
    },
    getType(row) {
      let thisStore =
        this.storeTypeList.find((item) => item.id === row.typeId) || {};
      return thisStore.name;
    },
    handleUpload(index, row) {
      this.addDialogVisible = true;
      this.controlData = this.list[index];
    },
    updateStroeInfo(index,row){
      this.$router.push({path: 'add',query:{...row}});
    },
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 301);
      uploadFile1(form).then((res) => {
        if (res.status === ERR_OK) {
          this.imageUrl = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _uploadImage() {
      if (!this.imageUrl) {
        alert("请上传形象图后再操作！");
        return;
      }
      let param = {
        id: this.controlData.id,
        image: this.imageUrl,
      };
      loadingInstance(Loading);
      uploadStoreImage(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.controlData = null;
          this.imageUrl = null;
          this.addDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 点击分页
    pageChange(val) {
      this.pageNum = val;
      this.categoryDatas = [];
      this._getList();
    },
    // 门店分类
    getStoreType() {
      loadingInstance(Loading);
      getStoreType().then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.storeTypeList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 获取列表
    _getList() {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
      };
      loadingInstance(Loading);
      getStoreAuditList(param).then((res) => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.list = res.data.records;
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
      });
    },
  },
};
</script>
<style scoped>
.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
/* 商城的按钮的动态类名的设置 */
.red-button {
  background-color: rgb(249, 112, 112);
  color: white; /* 可选：如有需要可更改文本颜色 */
  /* 根据需要添加其他样式 */
}
</style>



// WEBPACK FOOTER //
// src/components/store/pageList.vue